import { fetcher } from "helpers/fetcher";

import { TUpdateJobListingReq, TUpdateJobListingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateJobListing = async (payload: TUpdateJobListingReq) => {
  return await fetcher<TUpdateJobListingRes, TUpdateJobListingReq["data"]>(
    ENDPOINT.CORPORATION.UPDATE_JOB_LISTING,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.UPDATE_JOB_LISTING.version,
        [API_HEADER.CORP_ID]: payload.idCorp,
      },
    }
  );
};

export const mutationUpdateJobListing = async (
  payload: TUpdateJobListingReq
) => {
  return (await updateJobListing(payload)).data;
};

mutationUpdateJobListing._key = (payload: TUpdateJobListingReq) => [
  ENDPOINT.CORPORATION.UPDATE_JOB_LISTING.url,
  payload,
];
